import {useQuery} from '@tanstack/react-query';
import {fetchEventSuggestions, fetchPhotographerSuggestions, SuggestionEntry} from './suggestionsApi';

const STALE_TIME = 10 * 60 * 1000; // suggestion lists change rarely — 10 minutes is plenty fresh

function byCountDesc(entries: SuggestionEntry[]): string[] {
    return [...entries].sort((a, b) => b.count - a.count).map((entry) => entry.name);
}

/** Photographer name suggestions from the club's own aggregated index, most-used first. */
export function usePhotographerSuggestions(): string[] {
    const query = useQuery<SuggestionEntry[]>({
        queryKey: ['suggestions', 'photographers'],
        queryFn: fetchPhotographerSuggestions,
        staleTime: STALE_TIME,
        retry: 1,
    });
    return query.data ? byCountDesc(query.data) : [];
}

/** Event tag suggestions from the club's own aggregated index, most-used first. */
export function useEventSuggestions(): string[] {
    const query = useQuery<SuggestionEntry[]>({
        queryKey: ['suggestions', 'events'],
        queryFn: fetchEventSuggestions,
        staleTime: STALE_TIME,
        retry: 1,
    });
    return query.data ? byCountDesc(query.data) : [];
}
